import slugify from "slugify";

export const safeSlugify = value => {
  return (
    slugify(value) ||
    value
      .toString()
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/&/g, "-and-")
      .replace(/^-+/, "")
      .replace(/-+$/, "")
  );
};

export const getDatesetFromHash = hash => {
  return hash.replace("#dataset=", "");
};

export const filterData = paths => {
  const filtered = Object.keys(paths)
    .filter(key => !key.includes("/query"))
    .reduce((obj, key) => {
      obj[key] = paths[key];
      return obj;
    }, {});

  const items = Object.entries(filtered).map(row => {
    return {
      key: row[0],
      description: row[1]["get"].description,
      summary: row[1]["get"].summary.replace("List - ", ""),
      tags: row[1]["get"].tags
    };
  });

  return items;
};
